import { computed, ref } from "vue";

export type ThemePreference = "light" | "dark" | "system";

const STORAGE_KEY = "eco_theme";
const preference = ref<ThemePreference>("system");
const systemDark = ref(false);
let initialised = false;

function readStored(): ThemePreference {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "light" || v === "dark") return v;
  } catch {
    /* приватный режим: остаёмся на системной теме */
  }
  return "system";
}

const isDark = computed(() => preference.value === "dark" || (preference.value === "system" && systemDark.value));

function apply() {
  document.documentElement.classList.toggle("dark", isDark.value);
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", isDark.value ? "#0e1014" : "#fbfcfd");
}

// Один общий экземпляр состояния: переключатель стоит в нескольких местах.
export function useTheme() {
  if (!initialised) {
    initialised = true;
    preference.value = readStored();
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    systemDark.value = mq.matches;
    mq.addEventListener("change", (e) => {
      systemDark.value = e.matches;
      apply();
    });
    apply();
  }
  function toggle() {
    preference.value = isDark.value ? "light" : "dark";
    try {
      localStorage.setItem(STORAGE_KEY, preference.value);
    } catch {
      /* не сохранилось - тема действует до перезагрузки */
    }
    apply();
  }
  return { isDark, toggle };
}
